import * as React from 'react';
import { BreadcrumbsContainer } from '../../Breadcrumbs';
import { NavigationContainer } from '../../Navigation';
import { InsidePageContent, IInsidePageContentProps } from '../InsidePageContent';
import * as style from '../InsidePage.css';

export class ViewDesktop extends React.Component<IInsidePageContentProps, {}> {
  public render() {
    return (
      <div className={style['container-inner_desktop']}>
        <BreadcrumbsContainer />
        <div className={style['content-wrap']}>
          <InsidePageContent content={this.props.content} />
          <NavigationContainer collapsible={false} />
        </div>
      </div>
    );
  }
}
